import React from "react";
import PropTypes from "prop-types";
import Grow from "material-ui/transitions/Grow";

// We can easily disable the animations with the variable below.
// We can have a new module that handles animations with actions like
// ENABLE_ANIMATIONS and DISABLE_ANIMATIONS which can be called with mobile
// devices or any device that sucks ass.
const shouldAnimate = true;

const render = props => {
  if (shouldAnimate) {
    return (
      <Grow
        in={props.in}
        style={{
          transformOrigin: "0 0 0",
          transitionDelay: props.delay
        }}
        {...(props.in ? { timeout: props.duration } : {})}
      >
        {props.children}
      </Grow>
    );
  } else {
    return props.children;
  }
};

const GrowTransition = props => {
  return render(props);
};

GrowTransition.propTypes = {
  in: PropTypes.bool.isRequired,
  delay: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired
};

export default GrowTransition;



// WEBPACK FOOTER //
// ./src/components/GrowTransition/GrowTransition.js